import './modal-window.sass'
// @ts-ignore
import close from '../../assets/close-gray.svg'
import { defineComponent, onMounted, onUnmounted } from 'vue'

export default defineComponent({
    name: 'modal-window',
    props: {
        onClose: {
            type: Function,
            required: true,
        },
    },
    setup(props, { slots }) {
        onMounted(() => {
            document.body.style.overflow = 'hidden'

        })
        onUnmounted(() => {
            document.body.style.overflow = 'auto'

        })
        return () => {
            return (
                <div class="custom-modal-window"
                    onClick={(event: Event) => {
                        const target = event.target as HTMLElement;
                        if (target.className === "custom-modal-window") {
                            props.onClose(false);
                        }
                    }}
                >
                    <div class="custom-modal-window-content">
                        <div class="custom-modal-window-content-inner">
                            <img class="custom-modal-window-close-button" src={close}
                                onClick={() => {
                                    props.onClose(false);
                                }}
                            />
                            <div class="custom-modal-window-content-block">
                                {// @ts-ignore
                                    slots.default()}
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }
})